import Vue from 'vue';
import { mapGetters } from 'vuex';
import { guid } from '@/mixins/guid';
import { refreshStates } from '@/mixins/refresh-states';
import { dynamicSetup } from '@/mixins/dynamic-setup';
import { siteBuilder } from '@/mixins/site-builder';
import tooltip from '@/mixins/components/tooltip';
import dropsLoader from '@/mixins/components/drops-loader';

export default Vue.component('data-product-store-payment', {
  template: require('./template.html'),
  name: 'data-product-store-payment',
  mixins: [guid, dynamicSetup, siteBuilder, refreshStates],
  components: {
    dropsLoader,
    tooltip,
  },
  computed: {
    ...mapGetters([
      'currentSite',
      'activeSiteType',
    ]),
    storeData() {
      return this.currentSite.dynamic.products;
    },
    stripeTooltip() {
      let tip = 'You will need to sign up for a Stripe account to recieve payments. Your secret key should be found in the Stripe dashboard under "developers".';
      if (this.stripeData.linked) {
        tip = 'Log into Stripe and make sure all of your important business information is set up (i.e. tax id or SSN). If Stripe needs any important information from you still, your funds/transactions may be frozen until completed.';
      }
      return tip;
    },
    stripeData() {
      const stripe = this.storeData.payments &&
        this.storeData.payments.services &&
        this.storeData.payments.services.stripe &&
        this.storeData.payments.services.stripe;
      return stripe || {};
    },
  },
  data() {
    return {
      loading: false,
      redirect: false,
      keyLoader: false,
      setupLoader: false,
      inputIsPassword: true,
      reSignup: false,
      email: '',
      unlink: false,
      initialEdits: {
        email: '',
      },
    };
  },
  props: ['props'],
  created() {
    if (this.noDynamicData(this.activeSiteType)) {
      this.dynamicSetup(this.activeSiteType);
    }
    this.checkStripeStatus();
  },
  mounted() {
    this.refreshState('storePayments', () => {
      window.localStorage.setItem('refreshState', false);
    });
  },
  methods: {
    async connectStripe() {
      this.$validator.validate('email', this.email).then(async (result) => {
        if (result) {
          this.setupLoader = true;
          this.redirect = true;
          try {
            const create = await this.$lightning([{
              name: 'createStripeAccount',
              payload: {
                email: this.email,
                siteId: this.currentSite._id,
              },
            }]);
            // fallback check for payment info
            this.paymentSetup();
            // set up the account id in state
            this.$store.dispatch('setGlobalValue', {
              item: this.currentSite.dynamic.products.payments.services.stripe,
              key: 'accountId',
              value: create.accountId,
            });
            window.localStorage.setItem('refreshState', 'storePayments');
            window.open(create.accountLink, '_self');
          } catch (e) {
            const message = e.message || e;
            this.$log.error(message);
            this.setupLoader = false;
            this.$store.dispatch('addNotification', {
              id: this.guid(),
              type: 'error',
              message,
            });
          }
        }
      });
    },
    async checkStripeStatus() {
      if (!this.stripeData.linked && this.stripeData.accountId) {
        this.setupLoader = true;
        try {
          const account = await this.$lightning([{
            name: 'getStripeConnectAccount',
            payload: {
              siteId: this.currentSite._id,
            },
          }]);
          if (account.detailsSubmitted) {
            this.$store.dispatch('setGlobalValue', {
              item: this.currentSite.dynamic.products.payments.services.stripe,
              key: 'linked',
              value: true,
            });
            await this.$lightning([{
              name: 'updateDynamic',
              payload: {
                siteId: this.currentSite._id,
                attr: 'products.payments.services.stripe.linked',
                value: true,
              },
            }]);
          }
        } catch (e) {
          const message = e.message || e;
          this.$log.error(message);
          this.$store.dispatch('addNotification', {
            id: this.guid(),
            type: 'error',
            message,
          });
        } finally {
          this.setupLoader = false;
        }
      }
    },
    async unlinkStripe() {
      this.setupLoader = true;
      try {
        const { services } = await this.$lightning([{
          name: 'unlinkStripeConnect',
          payload: {
            siteId: this.currentSite._id,
          },
        }]);
        this.$store.dispatch('setGlobalValue', {
          item: this.currentSite.dynamic.products.payments,
          key: 'services',
          value: services,
        });
        this.$store.dispatch('addNotification', {
          id: this.guid(),
          type: 'success',
          message: 'Successfully unlinked Stripe account!',
        });
        this.unlink = false;
      } catch (e) {
        const message = e.message || e;
        this.$log.error(message);
        this.$store.dispatch('addNotification', {
          id: this.guid(),
          type: 'error',
          message,
        });
      } finally {
        this.setupLoader = false;
      }
    },
    openOnboardLink() {
      this.setupLoader = true;
      this.redirect = true;
      window.localStorage.setItem('refreshState', 'storePayments');
      window.open(this.stripeData.onboardLink, '_self');
    },
    openNewTab(url) {
      window.open(url, '_blank');
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/dynamic-data/store/payment/index.js